import { atom } from 'jotai';
import { TrendingCategorySlugs } from '@/components/Header/trendingSearches';

/** Hydrated by `PageProviders`. Empty outside DACH, and when the category tree was unreachable. */
export const trendingCategorySlugsAtom = atom<TrendingCategorySlugs>({});
